
const _getLocalStore = (name) => {
	try {
		return JSON.parse(localStorage.getItem(name));
	} catch (err) {
		return null;
	}
};

const roundNumber = (num, scale) => {
	if (!(`${num}`).includes('e')) {
		return +(`${Math.round(`${num}e+${scale}`)}e-${scale}`);
	}
	const arr = (`${num}`).split('e');
	let sig = '';
	if (+arr[1] + scale > 0) {
		sig = '+';
	}
	return +(`${Math.round(`${+arr[0]}e${sig}${+arr[1] + scale}`)}e-${scale}`);
};

const convertCurrency = (price, exchangeCoefficient = 1) => {
	if (exchangeCoefficient === 1) {
		const x = price.toString();
		let lastThree = x.substring(x.length - 3);
		const otherNumbers = x.substring(0, x.length - 3);
		if (otherNumbers !== '') { lastThree = `,${lastThree}`; }
		const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
		return (res);
	}
	// Round to second decimal place
	const x = roundNumber((price / exchangeCoefficient), 2);
	return (x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
};

const PriceTagString = (session, price='', customExchange = null) => {
	let currency = 'INR';
	const localStoreCurrency = _getLocalStore('currentCurrency');
	if (localStoreCurrency) {
		currency = localStoreCurrency;
	} else if (session.currentCurrency) {
		currency = session.currentCurrency;
	} else if (session.country) {
		currency = session.country;
	}
	const { exchangeCoefficient } = session;
	if (currency === 'INR' || currency === 'IN') {
		return (`₹ ${convertCurrency(price)}`);
	}
	if (customExchange !== null) {
		return (`$ ${convertCurrency(price, customExchange)}`);
	}
	return (`$ ${convertCurrency(price, exchangeCoefficient)}`);
};



export default PriceTagString;
